export default __webpack_public_path__ + "static/media/avatar_20.c0a21f97.png";